<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ invalid, validated, handleSubmit, validate }"
  >
    <vx-card class="mt-5">
      <div class="p-6 invoice-detail">
        <h3>#{{ form.uuid }}</h3>

        <!-- Overview Info -->
        <vx-card class="mt-base" title="Overview" no-shadow card-border>
          <div class="pl-3 pr-3 vx-row">
            <div class="w-full md:w-1/2 sm:w-1/2">
              <label class="text-sm text-black">Submission ID:</label><br />
              <p>{{ form.submissionId }}</p>
            </div>
            <div class="w-full md:w-1/2 sm:w-1/2">
              <label class="text-sm text-black">Status:</label><br />
              <vs-chip
                :color="getStatusColor(form.submissionStatus)"
                class="product-order-status"
              >
                {{ form.submissionStatus }}
              </vs-chip>
            </div>
          </div>
        </vx-card>
        <!-- End Overview Info -->

        <vx-card class="mt-5">
          <vs-table
            stripe
            ref="table"
            v-if="validationErrors"
            :data="validationErrors"
          >
            <template slot="thead">
              <vs-th>Item(s)</vs-th>
            </template>
            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p>{{ tr.message }}</p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
        <vx-card class="mt-base" no-shadow card-border v-if="form.eInvoices">
          <h4 class="mb-3 card-title">
            Submitted Documents ({{ form.eInvoices ? form.eInvoices.length : '0' }})
          </h4>
          <vs-table stripe ref="table" :data="form.eInvoices">
            <template slot="thead">
              <vs-th sort-key="id">Document Num</vs-th>
              <vs-th sort-key="docNo">Type</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
              <vs-tr
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                  class="selected activeEdit"
              >
                <vs-td>
                  <a @click="onViewEInvoice(tr.docNo)">{{ tr.docNo }}</a>
                </vs-td>
                <vs-td>
                  <p>{{ getDocType(tr.type) }}</p>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
        <!-- Items Info -->
        <vx-card class="mt-base" no-shadow card-border v-if="form.accepted && form.accepted.length > 0">
          <h4 class="mb-3 card-title">
            Accepted Documents ({{ form.accepted.length }})
          </h4>
          <vs-table stripe ref="table" :data="form.accepted">
            <template slot="thead">
              <vs-th sort-key="id">ID</vs-th>
              <vs-th sort-key="docNo">Document Num</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                  class="selected activeEdit"
                >
                  <vs-td>
                    <p>{{ tr.uuid }}</p>
                  </vs-td>
                  <vs-td>
                    <p><a @click="onViewEInvoice(tr.invoiceCodeNumber)">{{ tr.invoiceCodeNumber }}</a></p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
        <vx-card class="mt-base" no-shadow card-border v-if="form.rejected && form.rejected.length > 0">
          <h4 class="mb-3 card-title">
            Rejected Documents ({{ form.rejected.length }})
          </h4>
          <vs-table stripe ref="table" :data="form.rejected">
            <template slot="thead">
              <vs-th sort-key="docNo">Document Num</vs-th>
              <vs-th sort-key="errors">Errors</vs-th>
              <vs-th sort-key="details">Details</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
              <vs-tr
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                  class="selected activeEdit"
              >
                <vs-td>
                  <p><a @click="onViewEInvoice(tr.invoiceCodeNumber)">{{ tr.invoiceCodeNumber }}</a></p>
                </vs-td>
                <vs-td>
                  <p>{{ tr.error }}</p>
                </vs-td>
                <vs-td>
                  <p>{{ tr.details }}</p>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
<!--        <vx-card class="mt-base" no-shadow card-border v-if="form.submissionResponse.responseHeader">-->
<!--          <h4 class="mb-3 card-title">-->
<!--            Fail Submission-->
<!--          </h4>-->
<!--          <vs-table stripe ref="table">-->
<!--            <template slot="thead">-->
<!--              <vs-th sort-key="docNo">Submission Date</vs-th>-->
<!--              <vs-th sort-key="errors">Status</vs-th>-->
<!--              <vs-th sort-key="docNo">Error Code</vs-th>-->
<!--              <vs-th sort-key="errors">Error Message</vs-th>-->
<!--            </template>-->

<!--            <template slot-scope="{ data }">-->
<!--              <tbody>-->
<!--              <vs-tr-->
<!--                  class="selected activeEdit"-->
<!--              >-->
<!--                <vs-td>-->
<!--                  <p>{{ form.submissionResponse.responseHeader.timestamp }}</p>-->
<!--                </vs-td>-->
<!--                <vs-td>-->
<!--                  <p>{{ form.submissionResponse.responseHeader.status }}</p>-->
<!--                </vs-td>-->
<!--                <vs-td>-->
<!--                  <p>{{ form.submissionResponse.responseHeader.msgCode }}</p>-->
<!--                </vs-td>-->
<!--                <vs-td>-->
<!--                  <p>{{ form.submissionResponse.responseHeader.msgDesc }}</p>-->
<!--                </vs-td>-->
<!--              </vs-tr>-->
<!--              </tbody>-->
<!--            </template>-->
<!--          </vs-table>-->
<!--        </vx-card>-->
        <vx-card class="mt-base" no-shadow card-border v-if="history">
          <h4 class="mb-3 card-title">
            Submissions History
          </h4>
          <vs-table stripe ref="table" :data="history">
            <template slot="thead">
              <vs-th sort-key="docNo">Submission Date</vs-th>
              <vs-th sort-key="errors">Status</vs-th>
              <vs-th sort-key="docNo">Submission Code</vs-th>
              <vs-th sort-key="errors">Submission Message</vs-th>
              <vs-th sort-key="errors">Submission Details</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
              <vs-tr
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                  class="selected activeEdit"
              >
                <vs-td>
                  <p>{{ tr.submissionResponse.responseHeader.timestamp }}</p>
                </vs-td>
                <vs-td>
                  <p>{{ tr.submissionResponse.responseHeader.status }}</p>
                </vs-td>
                <vs-td>
                  <p>{{ tr.submissionResponse.responseHeader.msgCode }}</p>
                </vs-td>
                <vs-td>
                  <p>{{ tr.submissionResponse.responseHeader.msgDesc }}</p>
                </vs-td>
                <vs-td>
                  <p>{{ tr.submissionError }}</p>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>

      </div>
    </vx-card>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import GenericUpload from '@/views/components/override/GenericUpload.vue'
import vSelect from 'vue-select'
import LhdnSubmissionStatus from '@/mixins/lhdn-submission-status'
import VInput from '@/views/components/input/VInput.vue'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    GenericUpload,
    vSelect,
    VInput,
    ValidationObserver,
  },
  mixins: [LhdnSubmissionStatus],
  data() {
    return {
      invalid: true,
      serverError: [],
      supplierTin: null,
      isUpdate: false,
      isMounted: false,
      showSupplier: false,
      showBuyer: false,
      showRecipient: false,
      history: [],
      form: {
        accepted: [],
        rejected: [],
        items: [],
        linkedDocs: [],
        transactionsItems: [],
        supplier: {},
        buyer: {},
        recipient: {},
        submission: {},
      },
      settings: {
        // perfect scrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    activeTenantInfo() {
      return this.$store.state.AppActiveTenant || []
    },
  },
  mounted() {
    this.isMounted = true
  },
  created() {

    const id = this.$route.params.uuid
       this.fetchRecord(id)
       this.fetchHistory(id)
  },
  methods: {
    async fetchRecord(uuid) {
      let response = await this.$store
        .dispatch('lhdnSubmissions/fetchRecord', uuid)
        .catch((err) => {
          console.error(err)
        })
      this.form = response.data
      if(response.data.submissionResponse) {
        const submissionResponse = response.data.submissionResponse
        this.form.accepted = submissionResponse.acceptedDocuments
        this.form.rejected = submissionResponse.rejectedDocuments
        this.form.rejected.details = JSON.stringify(JSON.parse(submissionResponse.rejectedDocuments.error.details))
        this.form.rejected.error = submissionResponse.rejectedDocuments.error
        delete this.form.rejected.error.details
        console.log(`rejected ${JSON.stringify(this.form.rejected)}`)

      }
      console.log(`response ${JSON.stringify(this.form)}`)
      this.validationErrors = this.form.submissionResponse
        ? this.form.submissionResponse
        : null
      // this.buyerAddress = this.form.buyer.address
      // this.supplierAddress = this.form.supplier.address
      // this.recipientAddress = this.form.recipient.address
      const isValid =
        (await this.$refs.observer.validate()) &&
        (await this.$validator.validateAll())
      if (isValid) this.invalid = false
    },
    async fetchHistory(uuid) {
      let history = await this.$store
          .dispatch('lhdnSubmissions/fetchHistory', uuid)
          .catch((err)=>{
            console.error(err)
          })
      this.history = history.data.responses
    },
    async save() {
      const isValid =
        (await this.$refs.observer.validate()) &&
        (await this.$validator.validateAll())

      if (!isValid) {
        this.invalid = true
        return
      } else {
        this.invalid = false
        if (!this.form.customer) {
          delete this.form.customer
          delete this.form.customerId
        }
        await this.$store
          .dispatch('billingDocs/addRecord', this.form)
          .then((resp) => {
            if (resp.status == 200 || resp.status == 201) {
              this.$vs.notify({
                color: 'success',
                title: 'Invoice has been updated',
                text: `Invoice ${this.form.docNo} has been updated successfully`,
              })
            }
          })
          .catch((err) => console.error(err))
      }
    },
    async downloadEInvoicePdf() {
      if (this.form.eInvoice.generatedFileUrl) {
        window.open(this.form.eInvoice.generatedFileUrl, '_blank')
        return
      }

      let response = await this.$store
        .dispatch('einvoice/generateEInvoicePdf', this.form)
        .catch((err) => {
          console.error(err)
        })
      console.log(`eInvoice pdf - ${JSON.stringify(response.data)}`)
      this.form.eInvoice.generatedFileUrl = response.data.generatedFileUrl
      window.open(this.form.eInvoice.generatedFileUrl, '_blank')
      return
    },
    onViewEInvoice(docNo) {
      this.$router.push('/e-invoices/' + encodeURIComponent(docNo)).catch(() => {})
    },
    onViewPayment(id) {
      this.$router.push('/payment-transactions/' + id).catch(() => {})
    },
    onViewCustomerDetail(customerId) {
      this.$router.push('/customers/' + encodeURIComponent(customerId)).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.text-error {
  color: #e85600;
}

div .readOnly {
  padding: 0.3rem !important;
}

tr:has(.text-danger) {
  background-color: red;
}
</style>
